module.exports = __webpack_public_path__ + "static/media/YF87_5.8a7a5c9e.jpg";